import { dispatchAmplitudeEvent } from 'src/utils/amplitude'

import type { ProductItem } from '../../types/productItem'
import type { AddToCartFn } from './useAddToCartLogic'

// Helper para enviar evento de botão do modal
const sendCloseButtonEvent = (
  standardObject: Record<string, unknown>,
  productObject: Record<string, unknown>
) => {
  dispatchAmplitudeEvent({
    eventName: 'Click Button Modal',
    eventData: {
      ...standardObject,
      ...productObject,
      'modal nome': 'compra pela vitrine/plp',
    },
  })
}

export function useClearCartHandler(params: {
  hasMultipleItems: boolean
  currentSku: ProductItem
  cartWasClearedRef: React.MutableRefObject<boolean>
  clearCart: () => Promise<void>
  setOpenModalGiftCard: (value: boolean) => void
  setOpenModalPreSale: (value: boolean) => void
  openSkuSelectionModal: (callback?: () => void) => void
  addToCartFn: AddToCartFn
  standardObject: Record<string, unknown> | null
  productObject: Record<string, unknown> | null
}) {
  const {
    hasMultipleItems,
    currentSku,
    cartWasClearedRef,
    clearCart,
    setOpenModalGiftCard,
    setOpenModalPreSale,
    openSkuSelectionModal,
    addToCartFn,
    standardObject,
    productObject,
  } = params

  return async (e: React.MouseEvent<HTMLButtonElement>) => {
    await clearCart()
    setOpenModalGiftCard(false)
    setOpenModalPreSale(false)
    cartWasClearedRef.current = true

    if (hasMultipleItems) {
      const onModalClose = () => {
        if (standardObject && productObject) {
          sendCloseButtonEvent(standardObject, productObject)
        }

        cartWasClearedRef.current = false
      }

      openSkuSelectionModal(onModalClose)
    } else {
      addToCartFn('addToCart', currentSku, e)
    }
  }
}
